import gql from 'graphql-tag';

const GET_CHART = gql`
  query($chartId: ID!) {
    getChart(chartId: $chartId) {
      chartId
      name
      description
      groupBy #GroupBy
      internalName
      metrics {
        metricId
        name
        attribute
        metricFunction # MetricFunction
        filterCondition
        metricUnit
        metricOrder
        denominator
      }
      entity
      createdBy {
        userId
        name
        email
      }
      createdTime
      systemChart

      defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
      # possibleChartTypes
    }
  }
`;

const GET_CHARTS_LIST = gql`
  query($listInfo: ListInfoInput) {
    getCharts(listInfo: $listInfo) {
      charts {
        chartId
        name
        description
        internalName
        groupBy #GroupBy
        entity
        createdBy {
          userId
          name
          email
        }
        metrics {
          metricId
          name
          attribute
          metricFunction # MetricFunction
          filterCondition
          metricUnit
          denominator
          metricOrder
        }
        createdTime
        systemChart
        defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
        # possibleChartTypes
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CHARTS = gql`
  query($listInfo: ListInfoInput) {
    getCharts(listInfo: $listInfo) {
      charts {
        chartId
        name
        description
        groupBy #GroupBy
        internalName
        metrics {
          metricId
          name
          attribute
          metricFunction # MetricFunction
          filterCondition
          metricOrder
        }
        entity
        systemChart
        createdBy {
          userId
          name
          email
        }
        createdTime
        defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
        # possibleChartTypes
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_ALL_CHARTS = gql`
  query($listInfo: ListInfoInput) {
    getCharts(listInfo: $listInfo) {
      charts {
        chartId
        name
        description
        entity
        systemChart
        internalName
        createdBy {
          userId
          name
          email
        }
        createdTime
        defaultChartType
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const VIEW_CHART = gql`
  query($chartId: ID!, $condition: JSON) {
    viewChart(chartId: $chartId, condition: $condition)
  }
`;

const GENERATE_CHART_DATA = gql`
  query($input: ChartInput) {
    generateChartData(input: $input)
  }
`;

const PREVIEW_CHART = gql`
  query($PreviewChartInput: PreviewChartInput!) {
    previewChart(input: $PreviewChartInput)
  }
`;

// type GroupBy {
//   attribute: String
//   unit: String # GroupByUnit
// }

// enum GroupByUnit {
// 	DAY_OF_WEEK  # MONDAY, ...,SUNDAY
//   DAY_OF_MONTH # 1,2,3,....,31
//   WEEK # week with year like June 06, 2021
// 	MONTH_OF_YEAR # JANUARY, ..., DECEMBER
//   QUARTER # 1,2,3,4
//   YEAR
// }

// enum MetricFunction {
// 	TOTAL
//   PERCENTAGE
//   SUM
//   AVERAGE
//   MAX
//   MIN
// }

const GET_CHART_VIEWS = gql`
  query {
    getChartViews {
      id
      name
      module
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const EXPORT_CHART_CSV = gql`
  query($input: ChartIdentifierInput) {
    exportChart(input: $input)
  }
`;

export {
  GET_CHART,
  GET_CHARTS,
  GET_CHARTS_LIST,
  VIEW_CHART,
  GENERATE_CHART_DATA,
  GET_CHART_VIEWS,
  GET_ALL_CHARTS,
  PREVIEW_CHART,
  EXPORT_CHART_CSV
};
